import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DuplicateInitiationMutationVariables = Types.Exact<{
  input: Types.DuplicateInitiationInput;
}>;


export type DuplicateInitiationMutation = { __typename?: 'RootMutationType', duplicateInitiation?: { __typename?: 'DuplicateInitiationResult', initiation?: { __typename?: 'Initiation', id: string, tenantId: string, databaseId: any, sid: string, title: string, canUseVideoPreview?: boolean | null, previewVideoUrl?: string | null, thumbUrl?: string | null, updatedAt: any, owner?: { __typename?: 'User', id: string, displayName?: string | null, avatarUrl?: string | null } | null, channel?: { __typename?: 'Channel', id: string, title: string } | null, setting: { __typename?: 'InitiationSetting', id: string, locale: Types.StoryLocale, canShare: boolean, showBadge: boolean, linkPolicy: Types.ContentAccessPolicy, tenantMemberPolicy: Types.ContentAccessPolicy, isInteractive: boolean, widgetType: Types.WidgetType, widgetLive: boolean, showPages: boolean, orientation: Types.PlayerOrientationType, canChangeMediaSpeed: boolean, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType, gtmContainerId?: string | null }, endScreenSetting: { __typename?: 'EndScreenSetting', id: string, databaseId: any, title?: string | null, content?: string | null, textColor: string, blurEffect: number, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle: number, showCta: boolean, ctaText?: string | null, ctaUrl?: string | null, ctaBgColor?: string | null, ctaTextColor?: string | null, bgImageUpload?: { __typename?: 'ImageUpload', id: string, imageUrl?: string | null } | null, colors: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> }, widgetSetting: { __typename?: 'WidgetSetting', id: string, shape: Types.WidgetShape, size: Types.WidgetSize, allowHiding: boolean, borderColor?: string | null, bottomMargin?: number | null, caption: string, displayOnDesktop: boolean, displayOnMobile: boolean, leftAligned: boolean, showBorder: boolean, showTextBubble: boolean, sideMargin?: number | null, textBubbleBgColor?: string | null, textBubbleTextColor?: string | null, textBubbleMessage?: string | null, useVideoPreview: boolean, useFullScreen: boolean, initialPlaybackMode: Types.InitialPlaybackMode, widgetAlignment: Types.WidgetAlignment, widgetBorderRadius: number, widgetBorderThickness: number, widgetItemsPerRow: number, widgetItemWidth: number, widgetItemHeight: number, widgetItemGap: number, widgetIsResponsive: boolean }, ownerMember?: { __typename?: 'Member', id: string, displayName?: string | null, avatarUrl?: string | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const DuplicateInitiationDocument = gql`
    mutation duplicateInitiation($input: DuplicateInitiationInput!) {
  duplicateInitiation(input: $input) {
    initiation {
      id
      tenantId
      databaseId
      sid
      title
      canUseVideoPreview
      previewVideoUrl
      thumbUrl
      updatedAt
      owner {
        id
        displayName
        avatarUrl
      }
      channel {
        id
        title
      }
      setting {
        id
        locale
        canShare
        showBadge
        linkPolicy
        tenantMemberPolicy
        isInteractive
        widgetType
        widgetLive
        showPages
        orientation
        canChangeMediaSpeed
        showChoiceLetters
        choiceLetterType
        gtmContainerId
      }
      endScreenSetting {
        id
        databaseId
        title
        content
        textColor
        blurEffect
        bgType
        bgGradientType
        bgGradientAngle
        bgImageUpload {
          id
          imageUrl
        }
        colors {
          r
          g
          b
          a
          hex
        }
        showCta
        ctaText
        ctaUrl
        ctaBgColor
        ctaTextColor
      }
      widgetSetting {
        id
        shape
        size
        allowHiding
        borderColor
        bottomMargin
        caption
        displayOnDesktop
        displayOnMobile
        leftAligned
        showBorder
        showTextBubble
        sideMargin
        textBubbleBgColor
        textBubbleTextColor
        textBubbleMessage
        useVideoPreview
        useFullScreen
        initialPlaybackMode
        widgetAlignment
        widgetBorderRadius
        widgetBorderThickness
        widgetItemsPerRow
        widgetItemWidth
        widgetItemHeight
        widgetItemGap
        widgetIsResponsive
      }
      ownerMember {
        id
        displayName
        avatarUrl
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type DuplicateInitiationMutationFn = Apollo.MutationFunction<DuplicateInitiationMutation, DuplicateInitiationMutationVariables>;

/**
 * __useDuplicateInitiationMutation__
 *
 * To run a mutation, you first call `useDuplicateInitiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateInitiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateInitiationMutation, { data, loading, error }] = useDuplicateInitiationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateInitiationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateInitiationMutation, DuplicateInitiationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateInitiationMutation, DuplicateInitiationMutationVariables>(DuplicateInitiationDocument, options);
      }
export type DuplicateInitiationMutationHookResult = ReturnType<typeof useDuplicateInitiationMutation>;
export type DuplicateInitiationMutationResult = Apollo.MutationResult<DuplicateInitiationMutation>;
export type DuplicateInitiationMutationOptions = Apollo.BaseMutationOptions<DuplicateInitiationMutation, DuplicateInitiationMutationVariables>;